// extracted by mini-css-extract-plugin
export var collapsedSummary = "_i1-0";